/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Accordion, Button, Center, Stack, Text } from '@mantine/core';
import { FC, useContext, useEffect, useState } from 'react';
import { IconChevronRight, IconSignature } from '@tabler/icons';
import { useDisclosure } from '@mantine/hooks';
import { ExecutionStatus, WorkflowDTO } from '../../Types/LogT';
import Workflow from '../../Molecules/Event/Workflows/Workflow';
import { useTabFocus } from '../../Service/hooks/useTabFocus';
import { EventContext } from '../../Service/Context/EventContext';
import { RoutingS } from '../../Service/RoutingS';
import { useOwnContact } from '../../Service/Context/ContactContext';
import { MixpanelS } from '../../Service/MixpanelS';
import { ConstantS } from '../../Service/ConstantS';
import BodyConfetti from '../../Atoms/BodyConfeetti';

export const ExtendedOnboardingModal: FC<{ onboardingWorkflow: WorkflowDTO; close: () => void }> = ({
  onboardingWorkflow,
  close,
}) => {
  const { event } = useContext<any>(EventContext);
  const [confettiShoot, setConfettiShoot] = useState(false);
  const [executionStatus, setExecustionStatus] = useState<ExecutionStatus | null>(null);
  const [trigger, setTrigger] = useState<number>();
  const [opened, { toggle }] = useDisclosure(true);
  const { contact } = useOwnContact();
  const [showPortalButton, setShowPortalButton] = useState(false);
  const { portalLink } = event;

  useTabFocus(() => setTrigger(Date.now()));

  useEffect(() => {
    if (executionStatus === 'WAITING') {
      // Contract was shared --> Close workflow and show portal link button
      collectSignature();
    }
    if (executionStatus === 'COMPLETED') {
      finishOnboarding();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [executionStatus]);

  const collectSignature = () => {
    MixpanelS.track(ConstantS.TrackingEvents.WorkflowStarted, { src: 'onboarding' });
    toggle();
    setShowPortalButton(true);
  };

  const finishOnboarding = () => {
    MixpanelS.track(ConstantS.TrackingEvents.ContractSigned, { src: 'onboarding' });
    setShowPortalButton(false);
    setConfettiShoot(true);
  };

  const bookOnboardingCall = () => {
    if (contact) {
      MixpanelS.track(ConstantS.TrackingEvents.OnboardingCallRequested, { src: 'onboarding' });
      RoutingS.openInNewTab(
        `https://hey.bookitup.de/meetings/sebastian-mahlke/onboarding?embed=true&firstname=${
          contact.firstName
        }&lastname=${contact.lastName}&email=${encodeURIComponent(contact.email)}`,
      );
      close();
    }
  };

  return (
    <>
      <BodyConfetti active={confettiShoot} />
      {onboardingWorkflow && (
        <>
          {executionStatus === null && (
            <Text size="sm" color={'dimmed'}>
              Nehmen wir an, du hattest gerade dein Erstgespräch und sollst nun einen Vertrag für eine Foto-Reportage
              über 8 Stunden verschicken...Drück jetzt auf den Play-Button.
            </Text>
          )}
          <Accordion
            value={opened ? onboardingWorkflow.id : 'foo'}
            onChange={toggle}
            chevronPosition="left"
            chevron={<IconChevronRight size="1rem" />}
            styles={{
              chevron: {
                '&[data-rotate]': {
                  transform: 'rotate(90deg)',
                },
              },
            }}
          >
            <Workflow
              disableLinks
              showActions={false}
              workflow={onboardingWorkflow}
              previewOpened
              setShowPreview={() => null}
              onDelete={() => null}
              trigger={trigger}
              updateStatus={setExecustionStatus}
            />
          </Accordion>
          {showPortalButton && portalLink && (
            <>
              <Text align={'center'} mt="xl">
                Dein Beispiel-Vertrag ist nun bereit zur Unterschrift.
              </Text>
              <Text align={'center'} mt="xl">
                Jetzt darfst du Kunde spielen. Klick auf den Button und unterzeichne den Vertrag.
              </Text>
              <Text align={'center'} mt="xl">
                Komm anschließend wieder hinhin zurück.
              </Text>
              <Center mt="xl">
                <Button
                  className="highlight"
                  onClick={() => RoutingS.openInNewTab(portalLink)}
                  leftIcon={<IconSignature size={20} />}
                >
                  Online-Vertrag ansehen
                </Button>
              </Center>
            </>
          )}
          {executionStatus === 'COMPLETED' && (
            <Stack align="center" mt="xl">
              <Text>So einfach geht's 🎉</Text>

              <Text align={'center'}>
                Unser Ziel ist es, Deine Büroarbeit als Fotograf <b>so einfach wie möglich</b> zu machen.
              </Text>
              <Text align={'center'}>
                Lass uns schauen, ob bookitup auch für Dich perfekt geeignet ist. Such Dir jetzt einen kostenlosen
                Demo-Termin aus:
              </Text>

              <Button onClick={bookOnboardingCall}>Kostenlosen Demo-Termin vereinbaren</Button>
              <Button variant="subtle" onClick={close}>
                Ich möchte alleine weitermachen
              </Button>
            </Stack>
          )}
        </>
      )}
    </>
  );
};
